module.exports = __webpack_public_path__ + "static/media/menu.273656a4.svg";